/**
 * Learner-facing labels for guided tap-round “advance” buttons (not internal model terms).
 */

/**
 * @param {{
 *   engine?: string,
 *   isLast?: boolean,
 *   stepTitle?: string,
 *   activityTitle?: string,
 *   instruction?: string,
 * }} [opts]
 * @returns {string}
 */
export function getGuidedRoundNextButtonLabel(opts = {}) {
  const {
    engine = '',
    isLast,
    stepTitle = '',
    activityTitle = '',
    instruction = '',
  } = opts;
  const blob = `${stepTitle} ${activityTitle} ${instruction}`;
  if (isLast) {
    if (/\b(challenge|mini\s*challenge)\b/i.test(blob)) return 'Finish challenge';
    return 'Finish';
  }

  const strictClueGame =
    /\b(clue\s+hunt|guess\s+the\s+clue|mystery\s+clues?|clue\s+detective)\b/i.test(blob);
  if (strictClueGame) return 'Next clue →';

  const en = String(engine).toLowerCase();
  if (en === 'match' || en === 'engine_match') return 'Next question →';
  if (
    en === 'canvas_manipulative' ||
    en === 'canvas' ||
    en === 'engine_canvas_manipulative'
  ) {
    if (/\b(animal|creatures?|each\s+animal|who\s+lives|polar\s+bear|species)\b/i.test(blob)) {
      return 'Next animal →';
    }
    if (/\b(habitat|gallery|biome|forest|ocean|desert|where\s+.*\s+belong)\b/i.test(blob)) {
      return 'Next habitat →';
    }
    return 'Next question →';
  }
  if (/\b(pattern|repeat|growing\s+pattern)\b/i.test(blob)) return 'Next pattern →';
  if (/\b(circuit)\b/i.test(blob)) return 'Next circuit →';
  if (/\b(gear)\b/i.test(blob)) return 'Next gear →';
  if (en === 'multiple_choice' || en === 'engine_multiple_choice' || en === 'quiz') {
    return 'Next question →';
  }
  return 'Next →';
}
